import { useCountdown } from "@/hooks/useCountdown";
import { useAbVariant } from "@/hooks/useAbVariant";

export default function Footer() {
  const { formatted } = useCountdown();
  const { copy, variant } = useAbVariant();
  return (
    <footer
      data-testid="footer"
      className="px-6 md:px-12 lg:px-24 pt-24 md:pt-32 pb-12 bg-[#1A1A1A] text-[#F6F1E8]"
    >
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
        <div className="md:col-span-6">
          <p className="font-serif-display text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95]">
            Begin your <span className="italic">quiet</span>
            <br />
            love story.
          </p>
          <a
            href="#apply"
            data-testid="footer-cta"
            data-cta-variant={variant}
            className="mt-10 inline-flex items-center gap-3 bg-[#F6F1E8] text-[#1A1A1A] px-7 py-5 eyebrow hover:bg-white transition-colors"
          >
            {copy.full} →
          </a>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow opacity-60 mb-4">Studio</p>
          <address className="not-italic space-y-1.5 text-sm opacity-90 leading-relaxed">
            <p>Unit 6 Hodgson Court</p>
            <p>Hodgson Way, Wickford</p>
            <p>Essex, SS11 8XR</p>
            <p className="pt-2 italic opacity-80">By appointment only</p>
          </address>
        </div>

        <div className="md:col-span-2">
          <p className="eyebrow opacity-60 mb-4">Offer Closes</p>
          <p className="font-serif-display italic text-2xl tabular-nums">{formatted}</p>
          <p className="text-xs opacity-60 mt-2">A £500 gift, yours complimentary.</p>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-[#F6F1E8]/15 flex flex-col gap-4">
        <div className="flex flex-col md:flex-row gap-3 md:gap-8 items-start md:items-center text-xs">
          <span className="opacity-60">Proudly part of</span>
          <a
            href="https://www.wvegroup.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-wve-group-link"
            className="eyebrow link-underline opacity-90 hover:opacity-100"
          >
            WVE Group →
          </a>
          <a
            href="https://www.weddingvideo.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-wedding-video-essex-link"
            className="eyebrow link-underline opacity-90 hover:opacity-100"
          >
            Wedding Video Essex →
          </a>
        </div>
        <div className="flex flex-col md:flex-row gap-2 md:gap-4 items-start md:items-center justify-between text-xs opacity-60">
          <p>© {new Date().getFullYear()} Chic Wedding Photography · Est. Andy Thomas</p>
          <p>Photographed quietly across Essex, London, Kent, Suffolk &amp; beyond.</p>
        </div>
      </div>
    </footer>
  );
}
